import React, { memo } from 'react';
import { ListItem, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleOutlineRounded';
import RemoveIcon from '@mui/icons-material/RemoveCircleOutlineRounded';

const styles = {
    display: 'flex',
    justifyContent: 'end',
    padding: '0 10px 10px 10px',
};

const WaveLayerControls = memo(({ waveLayersLength, onAdd, onRemove }) => (
    <ListItem
        sx={styles}
    >
        <Tooltip
            title='Remove a layer from the visualizer.'
            placement='top'
            arrow
        >
            <span>
                <IconButton
                    size='small'
                    disabled={waveLayersLength <= 1}
                    onClick={onRemove}
                    aria-label='Remove a layer from the visualizer'
                >
                    <RemoveIcon />
                </IconButton>
            </span>
        </Tooltip>
        <Tooltip
            title='Add a layer to the visualizer.'
            placement='top'
            arrow
        >
            <span>
                <IconButton
                    size='small'
                    disabled={waveLayersLength >= 7}
                    onClick={onAdd}
                    aria-label='Add a layer to the visualizer'
                >
                    <AddIcon />
                </IconButton>
            </span>
        </Tooltip>
    </ListItem>
));


export default WaveLayerControls;